<template>
 <div class="fixed-right-box" @click="toSelectionList">
    <i class="basket gjw-iconfont gjw-icon-gouwuche2" :class="{'basket-animation':showAnimation}"/>
    <span>已选产品</span>
    <i class="product-plus" :class="{'product-plus-animation':showAnimation}">+1</i>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { RecordJournal } from '@/core/gcsUtils'
import checkLoginMixin from '@/mixins/checkLoginMixin'
import goToPageMixin from '@/mixins/goToPageMixin'
export default {
  name: 'NavShopBasket',
  mixins: [checkLoginMixin, goToPageMixin],
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      showAnimation: 'showShopAnimation'
    })
  },
  methods: {
    async toSelectionList() {
      const isLogin = await this.checkLogin()
      if (isLogin) {
        const routeInfo = { name: 'SelectionList' }
        RecordJournal('GoToSelectionListPage', routeInfo).catch()
        this.toPage(routeInfo)
      } else {
        await this.showLoginDialog()
      }
    },
  },
}
</script>
<style lang='less' scoped>
@keyframes basketScale {
    from,to{
      transform: scale(1);
    }
    50%{
      transform: scale(1.5);
    }
  }
@keyframes plusShow {
    from,to{
      opacity: 0;
      transform: scale(1);
    }
    50%{
      opacity: 1;
      transform: scale(1.5);
    }
  }
.fixed-right-box{
    padding: 4px 22px;
    border-radius: 0 0 4px 4px;
    font-size: 1rem;
    color: #ffffff;
    background: @theme-dark-bg;
    cursor: pointer;
    .basket{
      display: inline-block;
      color: #C8CAD3;
      margin-right: 12px;
      &.basket-animation{
        animation: basketScale .8s;
      }
    }
  .product-plus{
      position: absolute;
      color: @theme-hover-color;
      font-weight: bold;
      opacity: 0;
      left: 34px;
      &.product-plus-animation{
        animation: plusShow .8s;
      }
    }
  }
</style>
